module.exports = __webpack_public_path__ + "static/media/8.d0123569.jpg";